module.exports = {"app.preparing":"Preparing Messages"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en.json
// module id = 1109
// module chunks = 0